import React, { useState, useEffect } from 'react';
import ReactTableGenericForUsers from "Components/ReactTableGenericForUsers";
import 'react-datepicker/dist/react-datepicker.css';
import 'tippy.js/dist/tippy.css';
import Auth from "services/Auth";
import { useNavigate } from "react-router-dom"; // optional
import { BsArrowRightCircle } from 'react-icons/bs';
import UsersModal from './UsersModal';
import AuthService from 'Api/Auth';
import { useDispatch } from 'react-redux';
import { setUserRole } from 'reducers/UserPermission';
import { toast } from "react-toastify";
import { setUserProfilePicture } from "reducers/UserProfile";
import Tippy from "@tippyjs/react";
import TextLimit from 'Api/TextLimit';
import { setSubMenuClass } from 'reducers/ThemeOptions';
import { FaRegStar, FaStar } from "react-icons/fa";
import { DeviceModal } from './DeviceModal';
import { useUsers, useImpersonateUser, useCreateFavorite, useRemoveFavorite } from "Api/Admin/User";
import { resetMenuCount, resetVervangerMenuCount, setFeedbackCount, setWeekstateCount } from 'reducers/MenuCount';
import CommonService from 'Api/Common';
import { setHomeItemCount } from 'reducers/VervangerMenuCount';

const UsersTable = () => {
    // This is a custom filter UI for selecting
    // a unique option from a list
    const [reporterId, setReporterId] = useState(null);
    const [sorting, setSorting] = useState({
        key: 'fullname',
        order: ''
    });
    const [user, setUser] = useState("favorieten");
    const [pageSizeCount, setPageSizeCount] = useState(20);
    const [serachValue, setSerachValue] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeRowData, setActiveRowData] = useState({});
    const [selectedCommunityId, setSelectedCommunityId] = useState('');

    const { trigger: impersonateUser } = useImpersonateUser();
    const { trigger: createFavorite } = useCreateFavorite();
    const { trigger: removeFavorite } = useRemoveFavorite();

    const [modal, setModal] = useState({
        type: '',
        state: false,
    });

    const {
        data: response,
        isLoading,
        mutate,
    } = useUsers(pageSizeCount, pageNumber, serachValue, sorting, user, selectedCommunityId);

    const totalPageCount = response?.pageCount || 0;
    const totalCount=response?.totalCount
    const data =
        response?.data?.map(element => ({
            ...element,
            fullname: `${element.vFirstName} ${element.vLastName}`,
            vUserName: element.vUserName,
            vCity: element.vCity,
            vBusinessEmail: element.vBusinessEmail,
            vEmail: element.vEmail,
        })) || [];

    useEffect(() => {
        if (response?.allow_push_notification !== undefined) {
            localStorage.setItem(
                "allow_push_notification",
                response.allow_push_notification
            );
        }
    }, [response]);

    const handleInputChange = (val) => {
        setPageNumber(1);
        setSerachValue(val);
    };

    const userTablePageSize = (val) => {
        setPageNumber(1);
        setPageSizeCount(val);
    }

    const impersonate = (id) => {
        dispatch(setSubMenuClass(' hidden-submenu '));
        if (id) {
            impersonateUser({
                data: { admin_id: id }
            }).then(async (response) => {
                if (response.status === "success") {
                    if (response.user.appLastThreeMLogin == false) {
                        toast.success("Klaar om slimmer te werken? Gebruik de Clooser app en ervaar het verschil. Beschikbaar via Google play store en Apple App store", {
                            autoClose: 20000,
                            closeButton: true,
                        });
                    }
                    if (response?.roles.length !== 0 && response?.roles[0] !== "") {
                        const roles = AuthService.applySessionRoles(response);
                        dispatch(setUserRole(roles));
                        dispatch(setUserProfilePicture(response.user.profileImage));
                        Auth.setAuthenticatedUser(response.user);
                        if (response.user.impersonate) {
                            localStorage.setItem('IS_IMPERSONATE', response.user.impersonate);
                        }

                        navigate('/');

                        dispatch(resetMenuCount());
                        dispatch(resetVervangerMenuCount());

                        if (roles.includes("requestor")) {
                            const melderResponse =
                               await CommonService.getMelderCounts();

                            dispatch(
                                setFeedbackCount(
                                    melderResponse.data.countsArray.feedbackCount
                                )
                            );

                            dispatch(
                                setWeekstateCount(
                                    melderResponse.data.countsArray
                                        .weekReportActualCount
                                )
                            );
                        }

                        if (roles.includes("substitutor")) {
                            const substitutorResponse =
                               await CommonService.getSubstitutorCounts();

                            dispatch(
                                setHomeItemCount(
                                    substitutorResponse.data.countsArray
                                        .homeItemCount
                                )
                            );
                        }


                       // move to "/" as admin got new role and can't see Beheer page
                    } else {
                        toast["warning"]("Gebruiker heeft geen rol!")
                    }
                }

            }).catch(() => console.error);
        }
    }

    const paginate = (val) => {
        setPageNumber(val);
    }

    const toggleFavorite = (iFavAdminId, isFavorite) => {
        const currentUser = Auth.getAuthenticatedUser();
        const iAdminId = currentUser?.iAdminId;

        if (isFavorite) {
            removeFavorite({
                method: "delete",
                url: `remove-favorite-user/${iFavAdminId}`
            })
                .then((res) => {

                    if (res?.status === 200) {
                        toast.success("Verwijderd uit favorieten");
                        mutate();
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast.error("Verwijderen mislukt");
                });
        } else {
            createFavorite({
                data: {
                    iAdminId,
                    iFavAdminId
                }
            })
                .then((res) => {
                    if (res?.status === 200 || res?.status === 201) {
                        toast.success("Toegevoegd aan favorieten");
                        mutate();
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast.error("Toevoegen mislukt");
                });
        }
    };
    const filterList = (val) => {
        handleInputChange(val);
    }

    const columns = [
        {
            header: 'Clooser-Id',
            accessorKey: 'iAdminId',
        },
        {
            header: 'Gebruikersnaam',
            accessorKey: 'vUserName'
        },
        {
            header: 'Naam',
            accessorKey: 'fullname',
            cell: value => (
                window.innerWidth > 1250 ? TextLimit.AfwezigeLimitOptionOne(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)
                    : TextLimit.AfwezigeLimitOptionTwo(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)
            )
        },
        {
            header: 'Woonplaats',
            accessorKey: 'vCity'
        },
        {
            header: 'Mail zakelijk',
            accessorKey: 'vBusinessEmail'
        },
        {
            header: 'Mail prive',
            accessorKey: 'vEmail'
        },
        {
            header: 'Favorieten',
            accessorKey: 'iFavAdminId',
            cell: ({ row }) => {
                const isFavorite = row.original.iFavAdminId != null;

                return (
                    <div
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        onClick={() => toggleFavorite(row.original.iAdminId, isFavorite)}

                    >
                        {isFavorite
                            ? <FaStar className="othersSVGsFill" style={{ marginLeft: '25px' }} />
                            : <FaRegStar className="othersSVGsFill" style={{ marginLeft: '25px' }} />}
                    </div>
                );
            }
        },

        {
            header: 'Rol',
            accessorKey: 'vRole',
            enableSorting: false,
            cell: value => (
                <Tippy content={value.row.original.vRole.join(", ")} placement="bottom"><span>
                    {value.row.original.vRole.map(role => role.charAt(0).toUpperCase()).join("/")}</span>
                </Tippy>
            )
        },
        {
            Header: 'Actie',
            accessorKey: 'Actie',
            enableSorting: false,
            cell: value => (
                <div className='d-flex align-items-center'>
                    <BsArrowRightCircle
                        className="cursor-pointer me-2 othersSVGs"
                        color="light"
                        size={17}
                        onClick={() => impersonate(value.row.original.iAdminId)} />
                    <i
                        className="pe-7s-config cursor-pointer othersSVGs"
                        style={{ fontSize: '21px', color: 'light' }}
                        onClick={() => { setReporterId(value.row.original.iAdminId); setActiveRowData(value.row.original); setModal({ type: 'USER_MODAL', state: true }) }}
                    />
                </div>
            )
        },
    ];

    const filterUsers = (row, values) => {
        let searchValues = values.split(/(\s+)/).filter(e => e.trim().length > 0);

        return searchValues.every((value) => {
            return Object.entries(row.original).some(([key, val]) => {
                return key !== "vRole" && key !== "Actie" && String(val).toLowerCase().includes(value.toLowerCase());
            });
        });
    }
    const userDetails = data.find(a => a.iAdminId === reporterId);
    const updateSortingHandler = (key, order) => {
        setSorting({
            key,
            order
        })
    }

    return (
        <div>
            <UsersModal modal={modal} modalHandler={setModal} userDetails={userDetails} reporterId={reporterId} setReporterId={setReporterId} activeRowData={activeRowData} refetchUserList={mutate} />
            <DeviceModal userDetails={userDetails} modal={modal} modalHandler={setModal} reporterId={reporterId} refetchUserList={mutate} />
         
            <ReactTableGenericForUsers
                data={data}
                columns={columns}
                userTablePageSize={userTablePageSize}
                filterList={filterList}
                totalPageCount={totalPageCount}
                filterRecords={filterUsers}
                paginate={paginate}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                pageSizeCount={pageSizeCount}
                showLoader={isLoading}
                tableClassName="mb-0 table table-borderless table-sm table-hover"
                setUser={setUser}
                user={user}
                selectedCommunityId={selectedCommunityId}
                setSelectedCommunityId={setSelectedCommunityId}
                updateSortingHandler={updateSortingHandler}
                backendSorting={true}
                backendSortingState={sorting}
                count={totalCount}
            />

        </div>

    )
}

export default UsersTable;
